import styled from "styled-components";

import { ringSpin, rotate3D } from "@pages/casino/assets/styles/animations";

export const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

export const PreloaderBg = styled.div`
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: radial-gradient(circle at center, #1a1a1a, #000);
	display: flex;
	align-items: center;
	justify-content: center;
	transition: opacity 0.6s ease;
`;

export const LogoWrapper = styled.div`
	position: relative;
	width: 150px;
	height: 150px;
	perspective: 1000px;
`;

export const MainLogo = styled.img`
	width: 100%;
	height: 100%;
	animation: ${rotate3D} 3s linear infinite;
	filter: drop-shadow(0 0 25px gold) brightness(1.2);
	transform-style: preserve-3d;
`;

export const LoadingRing = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 180px;
	height: 180px;
	border: 3px solid transparent;
	border-top: 3px solid gold;
	border-radius: 50%;
	transform: translate(-50%, -50%);
	animation: ${ringSpin} 2s linear infinite;
	opacity: 0.4;
`;

export const ExpandedLoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 30px;
	text-align: center;
	color: var(--main-text-color);
	font-size: 26px;
	font-weight: 700;
	letter-spacing: 0.78px;
	text-transform: uppercase;
	.loading-img {
		width: 64px;
	}
`;

export const GenericLoadingContainer = styled.img`
	width: 100px;
	height: 100px;
	margin-top: 30px;
`;
